import { mapper } from "src/app/tools/mapping/mapper";
import {  db } from "../db";
import { Canal } from "src/app/domain/Endoscope/canal";
import { PrelevementRepository } from "./prelevement.repository";
import { Injectable } from "@angular/core";
import { CanalEntity } from "../canal.entity";
import { EndoscopeEntity } from "../endoscope.entity";

@Injectable({
    providedIn: 'root',
})
export class CanalRepository {
    constructor(
        private prelevementRepository: PrelevementRepository
    ) { }

    async getCanalById(id: number) {
        return await db.canals.where('Id').equals(id).first(async ze => {
            const z = mapper.map(ze, CanalEntity, Canal);

            if (ze?.PrelevementId) {
                z.Prelevement = await this.prelevementRepository.getPrelevementById(ze?.PrelevementId)
            }

            return z;
        });
    }

    async getCanalEntityById(id: number) {
        return await db.canals.where('Id').equals(id).first(async ze => {
            return ze;
        });
    }

    async attachCanal(canal: Canal, endoscope: EndoscopeEntity) {
        let canalId: number;
        const ce = mapper.map(canal, Canal, CanalEntity);

        // const ee = await this.endoscopeRepository.getEndoscopeEntityById(endoscopeId);
        canalId = await db.canals.add(ce);
        endoscope.CanalIds = endoscope?.CanalIds ? [...endoscope.CanalIds, canalId] : [canalId]
        await db.endoscopes.update(endoscope.Id!, {
            CanalIds: endoscope?.CanalIds
        });

        if (canal.Prelevement) {
            await this.prelevementRepository.attachPrelevementToCanal(canal.Prelevement, canalId);
        }

        return canalId;
    }
}